// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"layout_wrapper__FQZuc","main":"layout_main__88FzF","with-header":"layout_with-header__FEdAV"};